import { render, staticRenderFns } from "./user-order.vue?vue&type=template&id=4034640b&scoped=true&"
import script from "./user-order.vue?vue&type=script&lang=js&"
export * from "./user-order.vue?vue&type=script&lang=js&"
import style0 from "./user-order.vue?vue&type=style&index=0&id=4034640b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4034640b",
  null
  
)

export default component.exports